(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2754],{

/***/ 56260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Home": function() { return /* binding */ Home; },
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ navigation_map; }
});

// EXTERNAL MODULE: ./pages/navigation-map/navigation-map.module.scss
var navigation_map_module = __webpack_require__(85192);
var navigation_map_module_default = /*#__PURE__*/__webpack_require__.n(navigation_map_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./app/hooks/go-back.hook.ts
var go_back_hook = __webpack_require__(71014);
// EXTERNAL MODULE: ./app/hooks/lang.ts + 22 modules
var lang = __webpack_require__(91289);
// EXTERNAL MODULE: ./app/components/icons/Loader.tsx
var Loader = __webpack_require__(37387);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./app/components/region-countries/region-countries.module.scss
var region_countries_module = __webpack_require__(36622);
var region_countries_module_default = /*#__PURE__*/__webpack_require__.n(region_countries_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./app/components/icons/Logo.tsx
var Logo = __webpack_require__(23583);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./app/components/region-countries/region-countries.component.tsx








var RegionCountries = function RegionCountries(_ref) {
  var regionPermalink = _ref.regionPermalink,
      countries = _ref.countries,
      label = _ref.label,
      className = _ref.className;
  var radioListRef = (0,react.useRef)(null);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (0,clsx_m/* default */.Z)((region_countries_module_default()).wrapper, className),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (region_countries_module_default()).header,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        children: label
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (region_countries_module_default()).radio_list,
      ref: radioListRef,
      children: countries.map(function (country, index) {
        var _country$permalink;

        var countryPermalinkSplit = (_country$permalink = country.permalink) === null || _country$permalink === void 0 ? void 0 : _country$permalink.split("/");
        var countryCode = countryPermalinkSplit && countryPermalinkSplit.length > 0 ? countryPermalinkSplit[countryPermalinkSplit.length - 1] : null;
        return countryCode && /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/navigation-map/".concat(countryCode),
          passHref: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            className: (0,clsx_m/* default */.Z)((region_countries_module_default()).radio_station, (region_countries_module_default()).show_station_names),
            children: [country !== null && country !== void 0 && country.logo || country !== null && country !== void 0 && country.logo ? /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              className: (region_countries_module_default()).cover,
              src: (country === null || country === void 0 ? void 0 : country.logo) || (country === null || country === void 0 ? void 0 : country.logo) || "",
              width: 100,
              height: 100,
              layout: "fixed",
              objectFit: "cover",
              alt: "",
              unoptimized: true
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (0,clsx_m/* default */.Z)((region_countries_module_default()).cover, (region_countries_module_default()).no_image),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Logo/* default */.Z, {})
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (region_countries_module_default()).station_title,
              children: country.name
            })]
          })
        }, "radio-station-".concat(index));
      })
    })]
  });
};
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
;// CONCATENATED MODULE: ./pages/navigation-map/index.tsx











var __N_SSG = true;
function Home(_ref) {
  var initialData = _ref.initialData;
  var t = (0,lang/* useTranslate */.q)();

  var _useRouter = (0,router.useRouter)(),
      isFallback = _useRouter.isFallback;

  (0,go_back_hook/* useGoBackHistory */.J)("INDEX");
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      titleTemplate: "%s",
      title: t("seo.navigation-map-index-title"),
      description: t("seo.navigation-map-index-description"),
      openGraph: {
        images: [{
          url: "https://www.radioline.co/open-graph.png",
          alt: "Radioline"
        }]
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (navigation_map_module_default()).container,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (navigation_map_module_default()).countries_wrapper,
        children: isFallback ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (navigation_map_module_default()).loader_container,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {})
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: initialData.map(function (region) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(RegionCountries, {
              regionPermalink: region.region.permalink,
              countries: region.countries,
              label: region.region.name,
              showNames: true
            }, "country-region-".concat(region.region.permalink));
          })
        })
      })
    })]
  });
}
/* harmony default export */ var navigation_map = (Home);

/***/ }),

/***/ 40712:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/navigation-map",
      function () {
        return __webpack_require__(56260);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 36622:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","header":"region-countries_header__BEQf0","buttons":"region-countries_buttons__aVmfP","arrow":"region-countries_arrow__PRwWz","arrow_back":"region-countries_arrow_back__2YATV","radio_station":"region-countries_radio_station__8PHvQ","radio_list":"region-countries_radio_list__HRrpv","cover":"region-countries_cover__bSghK","no_image":"region-countries_no_image__617Y7","station_title":"region-countries_station_title__IcDTw","show_station_names":"region-countries_show_station_names__tM8Hp","row":"region-countries_row__ALi6U","wrapped":"region-countries_wrapped__bzIBr","placeholder_item":"region-countries_placeholder_item__MDatT","load":"region-countries_load__Xn3Lk"};

/***/ }),

/***/ 85192:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","container":"navigation-map_container__7qtCO","inner-container":"navigation-map_inner-container__Hho0v","home_stations_wrapper":"navigation-map_home_stations_wrapper__Xir4o","home_podcasts_wrapper":"navigation-map_home_podcasts_wrapper__hWfsL","country_title":"navigation-map_country_title__fmq6R","countries_wrapper":"navigation-map_countries_wrapper__jESfr","loader_container":"navigation-map_loader_container__3LYRy"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,2962,9774,2888,179], function() { return __webpack_exec__(40712); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);